import useWindowDimensions from "../../utils/width";

const TradeEntryType = ({ trades, runSpeficCal, theme, showGross = false }) => {
  const { width } = useWindowDimensions();
  const isDark = theme[0] === "dark";

  const win = "#26a65d";
  const loss = "#f23645";
  const breakeven = "#ED9E0E";

  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "12px",
        width: "100%",
        maxWidth: "770px",
        backgroundColor: isDark ? "#1e1f23" : "#ffffff",
        border: `1px solid ${isDark ? "#2d2e33" : "#e5e7eb"}`,
        marginTop: "16px",
      }}
    >
      <div
        style={{
          fontSize: width <= 700 ? "16px" : "18px",
          fontWeight: "600",
          color: isDark ? "#e5e7eb" : "#374151",
          marginBottom: "16px",
        }}
      >
        Trade Entry Type
      </div>
      <table
      className={theme[0] === "dark" ? 'tableHoverEffectDark' : 'tableHoverEffectLight'}
        style={{
          tableLayout: "fixed",
          borderCollapse: "collapse",
          width: "100%",
          height: "200px",
          fontSize: width <= 700 ? "13px" : "14px",
          margin: "0 auto",
        }}
      >
        <thead
        className="tableHoverEffectOff"
          style={{ fontSize: width <= 700 ? "13px" : "16px", height: "50px" }}
        >
          <tr>
            <th></th>
            <th style={{ fontWeight: "400", color: win }}>Win</th>
            <th style={{ fontWeight: "400", color: breakeven }}>BE</th>
            <th style={{ fontWeight: "400", color: loss }}>Loss</th>
            <th style={{ fontWeight: "400" }}># Trades</th>
            <th style={{ fontWeight: "400" }}>Return %</th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ textAlign: "center" }}>
            <th style={{ fontWeight: "400" }} scope="row">
              RE
            </th>

            <td style={{ color: win }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Risk" &&
                    (t.outcomePC === "Win" || t.outcomeIC === "Win")
                ).length
              }
            </td>
            <td style={{ color: breakeven }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Risk" &&
                    (t.outcomePC === "Breakeven" || t.outcomeIC === "Breakeven")
                ).length
              }
            </td>
            <td style={{ color: loss }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Risk" &&
                    (t.outcomePC === "Loss" || t.outcomeIC === "Loss")
                ).length
              }
            </td>
            <td>{trades.filter((t) => t.entryType === "Risk").length}</td>
            {runSpeficCal(trades.filter((t) => t.entryType === "Risk"), false, showGross)}
          </tr>
          <tr style={{ textAlign: "center" }}>
            <th style={{ fontWeight: "400" }} scope="row">
              RRE
            </th>

            <td style={{ color: win }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Reduced Risk" &&
                    (t.outcomePC === "Win" || t.outcomeIC === "Win")
                ).length
              }
            </td>
            <td style={{ color: breakeven }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Reduced Risk" &&
                    (t.outcomePC === "Breakeven" || t.outcomeIC === "Breakeven")
                ).length
              }
            </td>
            <td style={{ color: loss }}>
              {
                trades.filter(
                  (t) =>
                    t.entryType === "Reduced Risk" &&
                    (t.outcomePC === "Loss" || t.outcomeIC === "Loss")
                ).length
              }
            </td>

            <td>
              {trades.filter((t) => t.entryType === "Reduced Risk").length}
            </td>
            {runSpeficCal(trades.filter((t) => t.entryType === "Reduced Risk"), false, showGross)}
          </tr>
          <tr style={{ textAlign: "center" }}>
            <th style={{ fontWeight: "400" }} scope="row">
              Total
            </th>

            <td style={{ color: win }}>
              {
                trades.filter(
                  (t) =>
                    (t.entryType === "Risk" ||
                      t.entryType === "Reduced Risk") &&
                    (t.outcomePC === "Win" || t.outcomeIC === "Win")
                ).length
              }
            </td>
            <td style={{ color: breakeven }}>
              {
                trades.filter(
                  (t) =>
                    (t.entryType === "Risk" ||
                      t.entryType === "Reduced Risk") &&
                    (t.outcomePC === "Breakeven" || t.outcomeIC === "Breakeven")
                ).length
              }
            </td>
            <td style={{ color: loss }}>
              {
                trades.filter(
                  (t) =>
                    (t.entryType === "Risk" ||
                      t.entryType === "Reduced Risk") &&
                    (t.outcomePC === "Loss" || t.outcomeIC === "Loss")
                ).length
              }
            </td>
            <td> {trades.filter((t) => t.entryType).length}</td>
            {runSpeficCal(trades, false, showGross)}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TradeEntryType;